import { makeStyles } from 'tss-react/mui';
import { baseUrl } from '@sda/utils/url';
import { Signup as MainSignup } from '@client/components/Main/Signup/Signup';
import { StepFormWrapper } from '@client/components/common/StepFormWrapper';

const useStyles = makeStyles()((theme) => ({
  container: {
    maxWidth: theme.breakpoints.values.sm,
  },
}));

export const Signup = () => {
  const { classes } = useStyles();

  return (
    <StepFormWrapper
      imgSrc={baseUrl('media/signup/sidedoorcrop-colleenbrown.jpg')}
      imgTitle="Colleen Brown at Bay Street. Photo: Kim Eden."
      displayHeader={false}
      renderExplainer={(
        <div className={classes.container}>
          <MainSignup />
        </div>
      )}
    />
  );
};
